import React, { Component } from "react";
/* import UserService from "../../services/user.service"   //"../../../services/user.service";
import EventBus from "../../common/EventBus"; */

import dotenv from 'dotenv';
import Helper from '../DevServices/Helper'
import LoaderLine from '../DevServices/LoaderLine'
import { Redirect } from 'react-router-dom';
import { connect } from "react-redux";
import { compose } from "redux";
import { 
    thunkTest,
    t_decode_selected_dev, t_req_selected_dev,
    t_activator_actions_fromForm,
    update_selected_dev,
    t_delete_action_by_id,
    t_decode_selected_devID_softly_data,
    t_get_sensor_data_by_date,
    update_modal_chart,
    t_get_devinfo_by_desk_id_and_user_id,
    t_get_sensorlist_by_dev_id_and_user_id,

    t_graph_update_graph_selectedDate_by_devId_and_sensorId,
    t_graph_update_graph_field_prop_by_devId_and_sensorId,
    t_update_request_graph_by_devId_and_sensorId,
    t_update_request_graph_by_devId_and_sensorId2,
    t_update_request_graph_rx_data,
/*           t_graph_update_graph_selectedDate_by_devId_and_sensorId={this.props.t_graph_update_graph_selectedDate_by_devId_and_sensorId}
      t_graph_update_graph_field_prop_by_devId_and_sensorId = {this.props.t_graph_update_graph_field_prop_by_devId_and_sensorId}
      t_update_request_graph_by_devId_and_sensorId = {this.props.t_update_request_graph_by_devId_and_sensorId} 
      t_update_request_graph_rx_data = {this.props.t_update_request_graph_rx_data} */

} from "../../reducers/dev";
import Accordion from './Accordion/Accordion'

import SelectedDeviceInfo from "./SelectedDeviceInfo"
import StateList from "./StateList"
import ActionComposer from "./ActionComposer"
import ActionList from "./ActionList"
import EventList from "./EventList"
import LogList from "./LogList"
import Charts from "./Charts"
import DevList from "../../Projects/SelectedDesk/DevList"
//import SensorList from "../../Projects/SelectedDesk/SensorList"
import SensorList from "./SensorList"
import ModalChart from "../../Devices/DevServices/ModalChart"

//app/frontend/src/Projects/SelectedDesk/DevList.jsx
//import TemperatureHumidityChart from "../DevServices/TemperatureHumidityChart"
/*
import Helper from "../LocServices/Helper"
import { login } from "../../actions/auth"; */
/* import { reqLocId_findInfo, 

} from "../../reducers/location"; */



dotenv.config();

class PageSelectedDevice extends Component {
/*   constructor(props) {
    super(props);
    this.handlelocationId = this.handlelocationId.bind(this);
    this.onChangelocationId= this.onChangelocationId.bind(this);

    this.state = {
      //locationId: 0,
      isValidate: false,
      loading: false,
    };
  } */


  componentWillUnmount(){
    clearInterval(this.interval);

    //return this.props.update_selected_dev_id(0)
  }
  
  componentDidMount(){

    //+++++++++++++++++++++++++++++++++++++++++++
    const rx_dev_id = this.props.match.params.dev_id
    this.props.update_selected_dev('id', rx_dev_id)
    this.props.t_get_devinfo_by_desk_id_and_user_id()
    this.props.t_get_sensorlist_by_dev_id_and_user_id()
    //console.log(rx_dev_id)
/* 
    //GET actions data, Get state data, Get log data

    //RRR Programm time manage constructor 
    //Get Data Prtesentation
*/
    //this.props.t_decode_selected_dev(rx_dev_id)
    //console.log('page1 ')
    this.props.t_req_selected_dev(rx_dev_id)
    this.props.t_decode_selected_devID_softly_data(rx_dev_id);

      // Set up the interval to fetch data every 5 seconds
      this.interval = setInterval(() => {
        this.props.t_req_selected_dev(rx_dev_id); //main info (sensor data)
        this.props.t_decode_selected_devID_softly_data(rx_dev_id); //additional info (log, state, actions)

        this.props.t_get_devinfo_by_desk_id_and_user_id()
        this.props.t_get_sensorlist_by_dev_id_and_user_id()
        console.log('PageSelectedDevice. Refresh data timer. 5s')
    }, this.props.dev.refreshDataTime);
   
  }

  

  render() {
    if (!this.props.user){
      window.location.href = process.env.REACT_APP_HOST+"/login";
      return null; // Return null to avoid rendering anything else
    } 
/*     console.log(this.props.dev.selectedDev.id == null)
    if (this.props.dev.selectedDev.id == null){
      window.location.href = "https://google.com";
      return null; // Return null to avoid rendering anything else
    } */
      //console.log(this.props.dev.selectedDev.v2_sensors.sensor_list)

    return (
    <div className="">
{/*        <button
        onClick={()=>{
          //console.log("Hello Test")
          this.props.t_get_sensor_data_daily_by_selectedDevId_sensorId();
          //Get hourly data
          //this.props.thunkTest(this.props.user.accessToken)
        }}
      >Click Me2</button> 
      <TemperatureHumidityChart /> */}


      {/* <LoaderLine /> */}
{/*       <SelectedDeviceInfo
      selectedDev = {this.props.dev.selectedDev}
      isLoading = {this.props.dev.isLoading}
      /> */}

      <DevList data = {this.props.dev.selectedDev.v2_devinfo}
      isLoading = {this.props.dev.isLoading}
      />

      <SensorList 
      data = {this.props.dev.selectedDev.v2_sensors.sensor_list}
      t_graph_update_graph_selectedDate_by_devId_and_sensorId={this.props.t_graph_update_graph_selectedDate_by_devId_and_sensorId}
      t_graph_update_graph_field_prop_by_devId_and_sensorId = {this.props.t_graph_update_graph_field_prop_by_devId_and_sensorId}
      t_update_request_graph_by_devId_and_sensorId2 = {this.props.t_update_request_graph_by_devId_and_sensorId2} 
      t_update_request_graph_rx_data = {this.props.t_update_request_graph_rx_data} 
      />

      <ModalChart 
            update_modal_chart = {this.props.update_modal_chart}
            isModal={this.props.dev.modalChart.isModal}
            modalTitle = {'this.props.dev.modalChart.modalTitle'}
            sensor_data_for_modal = {this.props.dev.request_graph_by_sensor.rx_data_by_date.rows}
            />

{/*       <Accordion 
        selectedDev = {this.props.dev.selectedDev}
        modalChart = {this.props.dev.modalChart}
        t_get_sensor_data_by_date = {this.props.t_get_sensor_data_by_date}
        update_modal_chart={this.props.update_modal_chart}
        

      /> */}

{/*       {this.props.dev.selectedDev.requestData.sensors_card_data?.length  && <Accordion 
        selectedDev = {this.props.dev.selectedDev}
      />} */}


{/*       <Charts 
        selectedDev = {this.props.dev.selectedDev}
      /> */}

{/*       {  this.props.dev.selectedDev.requestData?.sensors_card_data?.length !== 0
        && <Charts 
        selectedDev = {this.props.dev.selectedDev}
      />} */}

      <ActionComposer
      //json_actions = {this.props.dev.selectedDev}
      selectedDev = {this.props.dev.selectedDev}
      t_activator_actions_fromForm = {this.props.t_activator_actions_fromForm}
      />

      {/* {this.props.dev.selectedDev.type === 'automat' && <ActionComposer
      json_actions = {this.props.dev.selectedDev.json_actions}
      t_activator_actions_fromForm = {this.props.t_activator_actions_fromForm}
      />} */}
 

      <ActionList
        rx_action_list = {this.props.dev.selectedDev.rx_action_list}
        t_delete_action_by_id={this.props.t_delete_action_by_id}
      />
      <StateList 
        rx_state_list = {this.props.dev.selectedDev.rx_state_list}
      />  

      <EventList
        rx_event_list = {this.props.dev.selectedDev.rx_event_list}
      />
      <LogList
        rx_log_list = {this.props.dev.selectedDev.rx_log_list}
      /> 
      
      <Helper props={this.props} />
      
    </div>
    );
  }
}

function mapStateToProps(state) {
  //console.log(state)
  const { user, test } = state.auth;

  return {
    user,
    test,
    dev: state.dev,
/*    location: state.location */
  };
}

  const mapDispatchToProps = { 
    thunkTest,
    t_decode_selected_dev, t_req_selected_dev,
    update_selected_dev,
    t_activator_actions_fromForm,
    t_delete_action_by_id,
    t_decode_selected_devID_softly_data,
    t_get_sensor_data_by_date,
    update_modal_chart,
    t_get_devinfo_by_desk_id_and_user_id,
    t_get_sensorlist_by_dev_id_and_user_id,

    t_graph_update_graph_selectedDate_by_devId_and_sensorId,
    t_graph_update_graph_field_prop_by_devId_and_sensorId,
    t_update_request_graph_by_devId_and_sensorId,
    t_update_request_graph_by_devId_and_sensorId2,
    t_update_request_graph_rx_data,
/*     t_get_sensor_data_hourly_by_selectedDevId_sensorId,
    t_get_sensor_data_30m_by_selectedDevId_sensorId,
    t_get_sensor_data_daily_by_selectedDevId_sensorId */
  }



export default compose(
  connect(mapStateToProps, mapDispatchToProps)
  //withAuthRedirect
)(PageSelectedDevice);


/* 
==Selected device==
Generator comands
- comand composer
  - decode json comander
  - comand perfomance  
- command list

State viewer

Logs viewer

Events viewer

schedular composer
  - cron coder
  - start stop line
  - timer event

*/


const objForMysql = [
  {
    code: 1,
    rem: "Pulsar. Not for stateMemory",
    target: "Computer. Press reset button",
    inputType: "text",
    int_values: [
      { value: 1, inputText: "1s Restart" },
      { value: 7, inputText: "7s Hard Off"},
    ],
    float_value: [],
    str_value: [],
  },
  {
    code: 2,
    rem: "For stateMemory. Long term state. ",
    target: "Computer. HDD relay manipulation",
    inputType: "text",
    int_values: [
      { value: 1, inputText: "HDD Power On"},
      { value: 0, inputText: "HDD Power Off"},
    ],
    float_value: [],
    str_value: [],
  }
]